import { render, staticRenderFns } from "./ImageDisplay.vue?vue&type=template&id=73acb2b3&scoped=true"
import script from "./ImageDisplay.vue?vue&type=script&lang=js"
export * from "./ImageDisplay.vue?vue&type=script&lang=js"
import style0 from "./ImageDisplay.vue?vue&type=style&index=0&id=73acb2b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73acb2b3",
  null
  
)

export default component.exports